module.exports = __webpack_public_path__ + "img/create-24px.539b3c38.svg";